import Backgrounds from './Backgrounds';
import Fonts from './Fonts';
import Platforms from './Platforms';
import Sizes from './Sizes';
import Align from './Align';
import Colors from './Colors';

const Data = {
	Platforms: Platforms,
	Fonts: Fonts,
	Backgrounds: Backgrounds,
	Sizes: Sizes,
	Align: Align,
	Colors: Colors
}

export default Data


// WEBPACK FOOTER //
// ./src/data/index.js